import React from 'react';
import { FaCalendarTimes } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import { FaPencilAlt, FaCheckCircle, FaClock, FaTimesCircle } from 'react-icons/fa';
import './layout.css';

const LeaveLayout = ({ children }) => {
  return (
    <div className='container-fluid'>
      <h1 className="layout-title">
        <FaCalendarTimes className="leave-policy-icon" />
        Leave Information
      </h1>
      <hr />
      <section>
        <div className="nav-container">
          <ul className="nav-list">
          <li className="nav-item">
              <NavLink
                id="total-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/total-leave"
              >
                <FaCheckCircle className="nav-icon" /> Total Leaves
              </NavLink>
            </li>

            
            <li className="nav-item">
              <NavLink
                id="Leaves-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/Leaves"
              >
                <FaPencilAlt className="nav-icon" /> Add Leaves
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="approved-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/approved-leave"
              >
                <FaCheckCircle className="nav-icon" /> Approved Leave
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="pending-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/pending-leave"
              >
                <FaClock className="nav-icon" /> Pending Leave
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                id="rejected-leave-link"
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                to="/rejected-leave"
              >
                <FaTimesCircle className="nav-icon" /> Rejected Leave
              </NavLink>
            </li>

           
          </ul>
        </div>
        <div className="content">
          {children} {/* Render the child components here */}
        </div>
      </section>
    </div>
  );
};

export default LeaveLayout;
